import { P2GTableRow, P2GTableCell, P2GLink, P2GIcon, SvgCaretUp, SvgCaretDown, P2GCollapse } from '@parcel2go/core-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import Price from '../../price/price';
import { ProductCurrency, ProductItem, ProductSlots } from '../adapters/product-types';
import { ProductSummary } from '../summary/product-summary';
import { makeStyles } from 'tss-react/mui';

type ProductTableRowProps = {
  item: ProductItem;
  currency: ProductCurrency;
  index: number;

  slots?: ProductSlots;
};

const useStyles = makeStyles()(() => ({
  removeBorderBottom: { borderBottom: 'none' },
  arrowSpace: { display: 'inline-flex', gap: '8px', alignSelf: 'flex-end' },
  removePaddingTopAndBottom: {
    paddingBottom: 0,
    paddingTop: 0
  }
}));

export function ProductTableRow({ item, currency, index, slots }: ProductTableRowProps) {
  const { t } = useTranslation(TranslationNamespaces.COMPLETE);
  const [isOpen, setIsOpen] = useState(false);
  const { classes } = useStyles();

  return (
    <>
      <P2GTableRow>
        <P2GTableCell
          classNames={classes.removeBorderBottom}
          align="center"
          sx={{ display: { xs: 'none', sm: 'table-cell' } }}
        >
          {index + 1}
        </P2GTableCell>
        <P2GTableCell classNames={classes.removeBorderBottom}>
          {item.destination.contactName} - {item.destination.property} {item.destination.street}{' '}
          {item.destination.postcode}
        </P2GTableCell>
        <P2GTableCell
          classNames={classes.removeBorderBottom}
          align="center"
          sx={{ display: { xs: 'none', sm: 'table-cell' } }}
        >
          {item.parcels.length}
        </P2GTableCell>
        <P2GTableCell classNames={classes.removeBorderBottom}>{item.service.name}</P2GTableCell>
        <P2GTableCell classNames={classes.removeBorderBottom}>
          <Price currency={currency} value={item.price.total} dataTestId="table-order-price" />
        </P2GTableCell>
        <P2GTableCell classNames={classes.removeBorderBottom} align="right">
          <P2GLink
            variant="body2"
            role="button"
            fontWeight="bold"
            dataTestId={'view-close-link-' + item.id}
            classNames={[classes.arrowSpace]}
            onClick={() => setIsOpen((prevState) => !prevState)}
          >
            <span>
              {isOpen
                ? t('TABLE_ORDER_SUMMARY_ROW_CLOSE', { defaultValue: 'Close' })
                : t('TABLE_ORDER_SUMMARY_ROW_OPEN', { defaultValue: 'View' })}
            </span>
            <P2GIcon size="xs">{isOpen ? <SvgCaretUp /> : <SvgCaretDown />}</P2GIcon>
          </P2GLink>
        </P2GTableCell>
      </P2GTableRow>
      <P2GTableRow>
        <P2GTableCell colSpan={6} classNames={!isOpen ? classes.removePaddingTopAndBottom : undefined}>
          <P2GCollapse in={isOpen} timeout={800}>
            <ProductSummary item={item} currency={currency} slots={slots} index={index} />
          </P2GCollapse>
        </P2GTableCell>
      </P2GTableRow>
    </>
  );
}
